module.exports = __webpack_public_path__ + "media/images/upload-new-users-3bd66f138226ccc21b536f8052600c1f.png";